import React from "react";
import { useAppSelector } from "../../custom-hooks/redux/redux";
import { NotAuthorizedPage } from "../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";

const PerformanceReviews = () => {
  const currentUserAuthorizations = useAppSelector((state) => state.currentUserReducer.currentUserAuthorizations);
  const hasAccess = currentUserAuthorizations?.canChangeAll || currentUserAuthorizations?.canViewAll;

  return (
    <>
      {hasAccess ? (
        <React.Fragment>
          <iframe
            title="Performance Reviews"
            src="https://focus-slab-41126700.figma.site/"
            width="100%"
            height="1280px"
          />
        </React.Fragment>
      ) : (
        <NotAuthorizedPage />
      )}
    </>
  );
};

export default PerformanceReviews;
